import { render, staticRenderFns } from "./channelPage.vue?vue&type=template&id=3b03a3fc&scoped=true&"
import script from "./channelPage.vue?vue&type=script&lang=js&"
export * from "./channelPage.vue?vue&type=script&lang=js&"
import style0 from "./channelPage.vue?vue&type=style&index=0&id=3b03a3fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03a3fc",
  null
  
)

export default component.exports